import { render } from "./PsoSignatoryControl.vue?vue&type=template&id=36288dec&scoped=true"
import script from "./PsoSignatoryControl.vue?vue&type=script&lang=js"
export * from "./PsoSignatoryControl.vue?vue&type=script&lang=js"

import "./PsoSignatoryControl.vue?vue&type=style&index=0&id=36288dec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36288dec"]])

export default __exports__